/*
 * @Descripttion: 工具集
 * @version: 1.1
 * @LastEditors: sakuya
 * @LastEditTime: 2021年7月20日10:58:41
 */
import Cookies from 'js-cookie';

const tool = {}

/* localStorage */
tool.data = {
    set(table, settings) {
        var _set = 'object' === typeof settings ? JSON.stringify(settings) : settings
        return localStorage.setItem(table, _set);
    },
    get(table) {
        var data = localStorage.getItem(table);
        if (!data) {
            //尝试从window全局对象获取
            if ('undefined' != typeof Window[table]) {
                data = Window[table];
            } else {
                //尝试从window.document.cookies对象获取
                data = Cookies.get(table);
                //console.info('Cookies', table);
            }
        }

        try {
            return data.substring(0, 1) === '{' ? JSON.parse(data) : data
        } catch (err) {
            return null
        }
    },
    remove(table) {
        Cookies.remove(table);
        return localStorage.removeItem(table);
    },
    clear() {
        return localStorage.clear();
    }
}

/*sessionStorage*/
tool.session = {
    set(table, settings) {
        var _set = JSON.stringify(settings)
        return sessionStorage.setItem(table, _set);
    },
    get(table) {
        var data = sessionStorage.getItem(table);
        try {
            data = JSON.parse(data)
        } catch (err) {
            return null
        }
        return data;
    },
    remove(table) {
        return sessionStorage.removeItem(table);
    },
    clear() {
        return sessionStorage.clear();
    }
}

/* Fullscreen */
tool.screen = function(element) {
    var isFull = !!(document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
    if (isFull) {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    } else {
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        }
    }
}

/* 复制对象 */
tool.objCopy = function(obj) {
    return JSON.parse(JSON.stringify(obj));
}

/* 日期格式化 */
tool.dateFormat = function(date, fmt = 'yyyy-MM-dd hh:mm:ss') {
    date = new Date(date)
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}

/* css 解析生成追加 */
tool.css = {
    parse: function(data) {
        let css_all = '';
        data.forEach(item => {
            let css_temp = `${item.name} {`
            item.style.forEach(item2 => {
                css_temp += `${item2.name}:${item2.value}; `
            });
            css_temp += `}`
            css_all += css_temp
        });
        return css_all
    },
    append(data) {
        let css;
        if ('string' === typeof data) {
            css = data
        } else {
            css = tool.css.parse(data)
        }
        let style = document.createElement("style");
        style.type = 'text/css';
        let body = document.querySelector("head");
        body.append(style);
        let b = css.replace(/;/g, " !important;");
        let html = b;
        style.innerHTML = html;

    }
}


export default tool


// WEBPACK FOOTER //
// ./src/utils/tool.js